import { Component } from "react";
import store from "../redux/store";
import { Realtime } from "ably/browser/static/ably-commonjs.js";
import { presenceJoin, presenceLeave, receivedAblyMessage } from "../redux/actions";
// import { ABLY_API_KEY } from "../redux/settings";
import { connect } from "react-redux";


/* index.js sets up window.Ably, for now. And transmission happens in action creators. */
/* TODO: Need to reboot component somehow if props.channel changes */

class UnconnectedAblyReceiver extends Component {

	constructor(props) {
		super(props);
		this.setupAbly();
		this.state = { connectionState:"Not yet initialised.", processedFirstControlMessage: false };
	}

	/* FIXME: AblyTransmitter won't work until this has been called... but we need nick_name as a clientID so we can't do it until we've finished with Settings! */
	setupAbly() {
		/* Also: Really? Stashing on 'window'? There must be a better way - perhaps put pending messages into the store and have this component react to them and send them. */
		window.Ably = new Realtime({ key: window.ABLY_API_KEY, clientId: this.props.nick_name });
	}

    // //TODO: Refactor from AblyTransmitter.
    channelForRoomKey(namespace, key) {
		return (namespace + ":room_" + key);
	}
	componentDidMount() {
		var ch_control = window.Ably.channels.get("[?rewind=1]" + this.channelForRoomKey("control",this.props.room_key)); //grab the most recent Control message to get the current video state
		var ch_chat = window.Ably.channels.get(this.channelForRoomKey("chat",this.props.room_key)); // we can't trivially rewind chat because we'll ignore the echoes

		/* We ignore messages from ourselves except in the special case where we've processed zero control messages so far (so we're loading history)
		   in which case the one control message from history might well be from us */
		var messageListener = function(message) {
			if (message.data !== "") {
				if ((message.name === "control" && !this.state.processedFirstControlMessage) 
					|| (message.data.sender_nick_name !== this.props.nick_name)) {
						switch(message.name) {
							case "control":
								this.setState({ processedFirstControlMessage:true });
								console.log("Firing received with ",message.data);
								this.props.receivedAblyMessage(message.data);
								break;
							case "chat":
								this.props.receivedAblyMessage(message.data);
								break;
							default:
								// console.log("UNKNOWN MESSAGE TYPE");
								break;
						}	
				} 
			}
		};

		ch_control.subscribe(messageListener.bind(this));
		ch_chat.subscribe(messageListener.bind(this));

		ch_chat.presence.subscribe(member => {
			// console.log("PRESENCE",member);
			switch (member.action) {
				case "enter":
				case "present":
					store.dispatch(presenceJoin({ client_id: member.clientId, connection_id: member.connectionId }));
				break;
				case "leave":
					store.dispatch(presenceLeave(member.connectionId));
				break;
				default:
					
			}
		});

		ch_chat.presence.enter();
	}

	componentWillUnmount() {
		window.Ably.channels.get(this.channelForRoomKey("chat", this.props.room_key)).presence.leave();
		window.Ably.channels.get(this.channelForRoomKey("chat", this.props.room_key)).presence.unsubscribe();
		window.Ably.channels.get(this.channelForRoomKey("control", this.props.room_key)).unsubscribe();
		window.Ably.channels.get(this.channelForRoomKey("chat", this.props.room_key)).unsubscribe();

	}

	render() {
		return null;
	}
}

const mapStateToProps = state => ({ room_key: state.user.room_key, nick_name: state.user.nick_name });
export const AblyReceiver = connect(mapStateToProps,  { receivedAblyMessage })(UnconnectedAblyReceiver);


